import { createBarStore } from './createBarStore';
import type { AssignmentPacking } from '../types/ui/AsoebiAssignment';

/** The Assignments list's bar choices, and what the open assignment's bar needs to show. */
export interface AssignmentsBarState {
  archived: boolean;
  packing: AssignmentPacking | '';
  /** Ticked rows on the list. */
  chosen: number;
  /** The open assignment (editor page), as the buttons need it. */
  editor: {
    creating: boolean;
    canMarkPacked: boolean;
    canDelete: boolean;
    canSave: boolean;
    saving: boolean;
    dirty: boolean;
  };
}

export const NO_EDITOR: AssignmentsBarState['editor'] = {
  creating: false, canMarkPacked: false, canDelete: false, canSave: false, saving: false, dirty: false,
};

const store = createBarStore<AssignmentsBarState>({ archived: false, packing: '', chosen: 0, editor: NO_EDITOR });

export const getAssignmentsBar = store.get;
export const setAssignmentsBar = store.set;
export const resetAssignmentsBar = store.reset;
export const useAssignmentsBar = store.use;

/** Bar -> list: mark the ticked assignments packed. */
export const ASSIGNMENTS_MARK_PACKED_EVENT = 'assignments:mark-packed';
/** Bar -> editor. */
export const ASSIGNMENT_PACK_ALL_EVENT = 'assignment:pack-all';
export const ASSIGNMENT_DELETE_EVENT = 'assignment:delete';
export const ASSIGNMENT_SAVE_EVENT = 'assignment:save';
